import { commonUtils } from './common_utils';

export const financeAdListing = {
    showFinanceOffer() {
        let adIds = [];
        $('[id^=financeProviderMobile]').each(function() {
            adIds.push($(this).data('ad-id'));
        });

        if (adIds.length > 0) {
            let $financeProviderLoader = $('.financeProviderLoader');
            $financeProviderLoader.show();
            $.get(Routing.generate('finance_provider_detail'), `adIds=${adIds}`, function(response) {
                $.each(response.finance_minimum_month_prices, function(adId, price) {
                    let formatedPrice = `${commonUtils.numberFormatByLocale(price)} €/${Translations.month_short}`;
                    $(`#financeProvider${adId}`).text(`${Translations.finance_offer_short} ${formatedPrice}`).fadeIn();
                    $(`#financeProviderMobile${adId}`).text(`${Translations.finance_offer_short} ${formatedPrice}`).fadeIn();
                });
            }).done(function() {
                $financeProviderLoader.hide();
            }).fail(function() {
                $financeProviderLoader.hide();
            });
        }
    },
};
